import { AddressedPositionTypeEnum } from '@/services/ws-post/src/main/resources/rest-api';

export const REACH_BY_DELIVERY_FACTOR = 2.675;

export const DAYS_REQUIRED_TO_PREPARE_DELIVERY = 4;

export const HOLIDAYS = [
  '04-07-2023',
  '04-09-2023',
  '04-10-2023',
  '05-01-2023',
  '05-18-2023',
  '05-28-2023',
  '05-29-2023',
  '06-08-2023',
  '08-01-2023',
  '08-15-2023',
  '09-08-2023',
  '11-01-2023',
  '12-25-2023',
  '12-26-2023',
  '01-01-2024',
  '01-02-2024',
  '01-06-2024',
  '03-29-2024',
  '03-29-2024',
  '04-09-2024',
  '04-01-2024',
  '04-01-2024',
  '05-01-2024',
  '05-29-2025',
  '06-08-2025',
  '06-09-2025',
  '08-01-2025',
  '12-25-2025',
  '12-26-2025',
  '04-18-2025',
  '04-20-2025',
  '04-21-2025',
  '01-01-2026',
  '01-02-2026',
] as const;

export const MAILING_CHANNELS = [
  AddressedPositionTypeEnum.INITIAL_EMAIL,
  AddressedPositionTypeEnum.INITIAL_ADDRESSED,
  AddressedPositionTypeEnum.INITIAL_SHIPMENT,
  AddressedPositionTypeEnum.REMINDER_EMAIL,
  AddressedPositionTypeEnum.REMINDER_ADDRESSED,
  AddressedPositionTypeEnum.REMINDER_SHIPMENT,
] as const;

export const MAX_RUNTIME_DAYS = 350;

export const POST_ENDPOINTS = [
  import.meta.env.VITE_POST_CONSOLE_ENDPOINT,
  import.meta.env.VITE_POST_CONSOLE_ENDPOINT_LEGACY,
  import.meta.env.VITE_POSTNETZ_CONSOLE_ENDPOINT,
  import.meta.env.VITE_POSTNETZ_CONSOLE_ENDPOINT_LEGACY,
];
